import React from 'react';
import styled from 'styled-components';
import parser from 'html-react-parser';
import imgApproved from '../../../../../../../../assets/illustrations/ilustracion_approve.svg';
import imgDisapproved from '../../../../../../../../assets/illustrations/ilustracion_disapproved.svg';
import imgApprovedDsk from '../../../../../../../../assets/illustrations/ilustracion-approved-desktop.svg';
import imgDisapprovedDsk from '../../../../../../../../assets/illustrations/ilustración_disapproved_dsk.svg';
import imgInProcess from '../../../../../../../../assets/illustrations/application_process_360.svg';
import imgInProcessDsk from '../../../../../../../../assets/illustrations/application_process_740.svg';
import TextHelper from '../../../../../../../../core/helpers/TextHelper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
  border-radius: 8px;
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .wrapper__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .wrapper__title {
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #161d1f;
  }

  .wrapper__name_career {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #161d1f;
  }

  @media (min-width: 768px) {
    .wrapper {
      flex-direction: row;
    }
    .wrapper__title {
      text-align: left;
    }
    .wrapper__name_career {
      text-align: left;
    }
  }
`;

const ImageResponse = styled.div.attrs((props: any) => ({
  // isAccepted: props.isAccepted,
  imgMob: props.imgMob,
  imgDsk: props.imgDsk
}))`
  background-color: #d5e4f0;
  border-radius: 8px;
  height: 88px;
  content: url('${(props) => props.imgMob}');
  @media (min-width: 768px) {
    background-color: transparent;
    height: auto;
    align-self: flex-start;
    content: url('${(props) => props.imgDsk}');
  }
`;

const Container2 = styled.div`
  width: 100%;
  .link {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #4f6168;

    button.goToWhatsapp {
      color: #5b36f2;
    }
  }
`;

const Ul = styled.ul`
  list-style: disc;
  margin-left: 28px;
`;

const SummaryData = (props: any) => {
  const { abstract, newPeriod, newCampus, shift } = props;
  return (
    <Container2>
      <p>Resumen:</p>
      <Ul>
        <li> {abstract}. </li>
        {newCampus && <li>Para campus {newCampus}. </li>}
        {shift && <li>Turno {shift}.</li>}
        <li>Para ciclo {newPeriod}. </li>
      </Ul>
    </Container2>
  );
};
const convertData = (value: string) => {
  const chunks = value?.split('-').length;
  return chunks > 0 ? value?.split('-') : ['', value];
};

const RequestStatusResponse = (props: any) => {
  const {
    currentCareer,
    newCareer,
    requestDate,
    isAccepted,
    comentary,
    applySince,
    inProcess
  } = props;
  const newValue = convertData(newCareer);
  const currentValue = convertData(currentCareer);

  const textBefore0301 =
    'Tu solicitud de cambio de opción de estudio ha sido aprobada de manera satisfactoria, <b>podrás matricularte en tu nueva modalidad desde el día 03 de enero dentro de la matrícula extemporánea sin costo adicional.</b>';
  // const textFor20Enero = 'Tu solicitud de Cambio de opción de estudios, ha sido aprobado de manera satisfactoria, recuerda que no es necesario que realices ninguna gestión adicional. Podrás ver el cambio impactado en tus distintas plataformas y realizar tu matrícula en tu nueva modalidad en los siguientes 10 minutos.';

  const textFor20Enero = `Tu solicitud de Cambio de modalidad, ha sido aprobada de manera satisfactoria, recuerda que no es necesario que realices ninguna gestión adicional. Podrás ver el cambio impactado a partir de la matrícula <b>${applySince}</b> en adelante.`;

  const confirmText =
    new Date() >= new Date(2023, 0, 3, 8, 0) ? textFor20Enero : textBefore0301;

  const evalImg = () => {
    if (inProcess) {
      return { imgMob: imgInProcess, imgDsk: imgInProcessDsk };
    }
    return {
      imgMob: isAccepted ? imgApproved : imgDisapproved,
      imgDsk: isAccepted ? imgApprovedDsk : imgDisapprovedDsk
    };
  };
  return (
    <Container>
      <div className="wrapper">
        <ImageResponse {...evalImg()} />
        <div className="wrapper__content">
          {inProcess ? (
            <p className="wrapper__title">Tu solicitud está en proceso</p>
          ) : (
            <p className="wrapper__title">
              {isAccepted
                ? 'Tu solicitud ha sido aprobada'
                : 'Tu solicitud no procede'}
            </p>
          )}

          <div>
            {inProcess ? (
              <p className="wrapper__name_career">
                Podrás ver tu cambio impactado en unos minutos.
              </p>
            ) : (
              <>
                <p className="wrapper__name_career">
                  De {TextHelper.capitalize(currentValue[0])} -{' '}
                  <b>{TextHelper.capitalize(currentValue[1])}</b> {newValue[0]}{' '}
                  -<strong> {newValue[1]}. </strong>
                </p>
                <br />

                <p className="wrapper__name_career">
                  Fecha de solicitud: {requestDate}.{' '}
                </p>
                <br />

                <p className="wrapper__name_career">
                  {isAccepted ? (
                    <>{parser(confirmText)}</>
                  ) : (
                    <>{comentary || ''}</>
                  )}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

RequestStatusResponse.defaultPros = {
  inProcess: false
};

const MessageHelp = (props: any) => {
  const { onClick } = props;
  return (
    <Container2>
      <p className="link">
        ¿Algo no salió bien con este trámite? Contáctanos a través de{' '}
        <button
          className="goToWhatsapp"
          type="button"
          onClick={() => {
            onClick();
          }}
        >
          Solicitudes SAE.
        </button>
      </p>
    </Container2>
  );
};

export { SummaryData, RequestStatusResponse, MessageHelp };
